<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>

  <ng-container *ngIf="consulta">
    <ul class="card-list-striped py-1">
      <li>
        <span class="text-secondary">ENDEREÇO:</span>
        <span class="text-justify">{{ consulta?.endereco || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">BAIRRO:</span>
        <span>{{ consulta?.bairro || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">CIDADE:</span>
        <span>{{ consulta?.cidade || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">UF:</span>
        <span>{{ consulta?.uf || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">CEP:</span>
        <span>{{ consulta?.cep || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">TELEFONE:</span>
        <span>{{ consulta?.telefone != 'null' ? consulta?.telefone : 'NADA CONSTA' || msgNull }}</span>
      </li>
      <li>
        <span class="text-secondary">CELULAR:</span>
        <span>{{ consulta?.celular != 'null' ? consulta?.celular : 'NADA CONSTA' || msgNull }}</span>
      </li>
    </ul>
  </ng-container>
  
</app-card-consulta>